import api from '@/api/users';

const loginUser = (context, credentials) => new Promise(((resolve, reject) => {
  api.loginUser(credentials)
    .then((response) => {
      context.commit('storeApiKey', response.user.apiKey, { root: true });
      context.commit('SET_PROFILE', response.user);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));


const fetchLoggedInProfile = context => new Promise(((resolve, reject) => {
  api.fetchLoggedInProfile()
    .then((response) => {
      context.commit('SET_PROFILE', response.user);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const logOut = context => new Promise(((resolve) => {
  context.commit('storeApiKey', undefined, { root: true });
  context.commit('SET_PROFILE', undefined);
  resolve(true);
}));

const fetchUsers = (context, all = false) => new Promise(((resolve, reject) => {
  api.fetchUsers(all)
    .then((response) => {
      context.commit('SET_USERS', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const fetchUser = (context, userId) => new Promise(((resolve, reject) => {
  api.fetchUser(userId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const inviteUsers = (context, payload) => new Promise(((resolve, reject) => {
  api.inviteUsers(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const signUpForBeta = (context, email) => new Promise(((resolve, reject) => {
  api.signUpForBeta(email)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const fetchInvitation = (context, code) => new Promise(((resolve, reject) => {
  api.fetchInvitation(code)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const fetchOpenInvitations = () => new Promise(((resolve, reject) => {
  api.fetchOpenInvitations()
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const setTutorialSeen = context => new Promise((() => {
  context.commit('setTutorialSeen', {}, { root: true });
}));

const registrate = (context, payload) => new Promise(((resolve, reject) => {
  api.registrate(payload)
    .then((response) => {
      if (response.user) {
        context.commit('storeApiKey', response.user.apiKey, { root: true });
        context.commit('SET_PROFILE', response.user);
      }
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const registrateViaInvitation = (context, data) => new Promise(((resolve, reject) => {
  api.registrateViaInvitation(data.invitationCode, data.payload)
    .then((response) => {
      if (response.user) {
        context.commit('storeApiKey', response.user.apiKey, { root: true });
        context.commit('SET_PROFILE', response.user);
      }
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const generatePasswordReset = (context, email) => new Promise(((resolve, reject) => {
  api.generatePasswordReset(email)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const resetPassword = (context, data) => new Promise(((resolve, reject) => {
  api.resetPassword(data)
    .then((response) => {
      if (response.user) {
        context.commit('storeApiKey', response.user.apiKey, { root: true });
        context.commit('SET_PROFILE', response.user);
      }
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const getTransactionsForUser = (context, data) => new Promise(((resolve, reject) => {
  api.fetchTransactionsForUser(data.userId, data.page)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const updateUserProfile = (context, data) => new Promise(((resolve, reject) => {
  api.updateUserProfile({ user: data })
    .then((response) => {
      context.commit('SET_PROFILE', response);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const configurateCompany = (context, data) => new Promise(((resolve, reject) => {
  api.configurateCompany(data)
    .then((response) => {
      fetchLoggedInProfile(context).then(() => {
        resolve(response);
      });
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const uploadProfileImage = (context, data) => new Promise(((resolve, reject) => {
  api.uploadProfileImage(data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const toggleUserStatus = (context, userId) => new Promise(((resolve, reject) => {
  api.toggleUserStatus(userId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const changeRole = (context, userId) => new Promise(((resolve, reject) => {
  api.changeRole(userId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

const instantRegistration = (context, email) => new Promise(((resolve, reject) => {
  api.instantRegistration(email)
    .then((response) => {
      context.commit('storeApiKey', response.user.apiKey, { root: true });
      context.commit('SET_PROFILE', response.user);
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      reject(error);
    });
}));

export default {
  loginUser,
  fetchLoggedInProfile,
  logOut,
  fetchUsers,
  inviteUsers,
  signUpForBeta,
  fetchInvitation,
  setTutorialSeen,
  registrateViaInvitation,
  generatePasswordReset,
  resetPassword,
  fetchUser,
  getTransactionsForUser,
  registrate,
  updateUserProfile,
  configurateCompany,
  fetchOpenInvitations,
  uploadProfileImage,
  toggleUserStatus,
  changeRole,
  instantRegistration,
};

